import { FC, useMemo } from "react";
import { MerchantDataItem } from "../../../../services/getCurrentSn";
import {
  MRT_ColumnDef,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import useGetDocument from "@funded-here-interface/common/src/hooks/useGetDocument";
import { downloadFile } from "@funded-here-interface/common/src/Utils/file";
import { FileType } from "@funded-here-interface/common/src/constant/enum";
import { RootState } from "../../../../store";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useStyle } from "./Merchant.styles";
import { formatNumbersWithThousandSeperators } from "@funded-here-interface/common/src/Utils/formatter";

interface IProps {
  isLoading: boolean;
  data: MerchantDataItem[] | undefined;
}

const Merchant: FC<IProps> = ({ isLoading, data }) => {
  const useGetDocumentMutaiton = useGetDocument();
  const token = useSelector((state: RootState) => state.auth.token);
  const { classes } = useStyle();

  const downloadDocument = async (path: string) => {
    useGetDocumentMutaiton.mutate(
      { token, path },
      {
        onSuccess: (data: Blob) => {
          downloadFile(data, "Loan Agreement", FileType.PDF);
        },
        onError: (e) => {
          toast.error((e as Error).message);
        },
      }
    );
  };

  const columns = useMemo<MRT_ColumnDef<MerchantDataItem>[]>(
    () => [
      {
        accessorKey: "skuId",
        header: "SKU ID",
      },
      {
        accessorKey: "borrower",
        header: "Merchant",
      },
      {
        accessorKey: "loanAmount",
        header: "Loan Amount",
        Cell: ({ cell }) => (
          <p>
            {cell.getValue<string>()
              ? formatNumbersWithThousandSeperators(
                  parseFloat(cell.getValue<string>())
                )
              : "-"}
          </p>
        ),
      },
      {
        accessorKey: "intRate",
        header: "Int Rate",
        Cell: ({ cell }) => (
          <p>{`${(parseFloat(cell.getValue<string>()) * 100).toFixed(2)}%`}</p>
        ),
      },
      {
        accessorKey: "tenure",
        header: "Tenure",
      },
      {
        accessorKey: "agreement",
        header: "Loan Agreement",
        enableSorting: false,
        Cell: ({ cell }) => {
          const agreementPath = cell.getValue<string>();

          return agreementPath ? (
            <p
              className={classes.view}
              onClick={() => downloadDocument(agreementPath)}
            >
              Download
            </p>
          ) : (
            <p>-</p>
          );
        },
      },
    ],
    []
  );

  const table = useMantineReactTable({
    enableColumnActions: false,
    enableColumnFilters: false,
    paginationDisplayMode: "pages",
    state: { isLoading },
    columns,
    data: data ?? [],
    initialState: { density: "xs" },
    mantineTableProps: {
      withBorder: true,
    },
  });

  return <MantineReactTable table={table} />;
};

export default Merchant;
